import angular from 'angular';
import { ssDialogService } from 'app/services';
import editTestDialog from './dialog.editTestDialog';
import controller from './tests.controller';
import directive from './tests.directive';
import test from './test';


export default angular.module('app.components.advisory.bcp.tests', [
  editTestDialog,
  test,
  ssDialogService,
])
  .directive('bcpTests', directive)
  .controller('TestsController', controller)
  .name;

console.log('app.components.advisory.bcp.tests created');
